import { useUpdateDocumentTypeRecipients } from 'services/repositories/notificationsManagement/notificationsManagement';
import { useUpdateRelationshipResponsibleUsers } from 'services/repositories/relationships/relationships';
import { DocumentType } from 'support/types/dtos';
import portalSchema from 'support/types/schema-portal';

export type NotificationResolving = portalSchema.components['schemas']['NotificationResolving'];

type DocumentTypeRecipientsConfig = {
  type: 'documentType';
  documentType: DocumentType;
};

type RelationshipRecipientsConfig = {
  type: 'relationship';
  relationshipId: string;
  partnerId: string;
};

export type UpdateRecipientsConfig = DocumentTypeRecipientsConfig | RelationshipRecipientsConfig;

export const useUpdateRecipients = (config: UpdateRecipientsConfig) => {
  const docMutation = useUpdateDocumentTypeRecipients();
  const relMutation = useUpdateRelationshipResponsibleUsers();

  const save = async (emails: Array<string>, notificationResolving: NotificationResolving): Promise<Array<string>> => {
    if (config.type === 'documentType') {
      const response = await docMutation.mutateAsync({
        message_type: config.documentType,
        responsible: emails,
        notification_resolving: notificationResolving,
      });
      return response.data.unrecognized ?? [];
    }

    const response = await relMutation.mutateAsync({
      relationshipId: config.relationshipId,
      payload: {
        partner_id: config.partnerId,
        responsible: emails,
        notification_resolving: notificationResolving,
      },
    });
    return response.data.unrecognized ?? [];
  };

  const isSaving = docMutation.isLoading || relMutation.isLoading;

  return { save, isSaving };
};
